export const chat = {
  store_session: "chat/store/session/",
  store_message: "chat/store/message/",
  upload: "chat/upload/",
  read: "chat/message/read/",
  ws_store: "chat/ws/store/",
};
